import React from "react"
import NavigationGroupItem from "@components/shared/Navigation/NavigationGroupItem/NavigationGroupItem"

const NavigationGroup = ({ items, useTabIndexFrom }) => (
  <div className="sub-menu">
    <ul className="sub-menu-grid">
      {items.map((item, index) => (
        <NavigationGroupItem key={index} position={index} {...item} useTabIndex={useTabIndexFrom + index + 1} />
      ))}
    </ul>
  </div>
)

export default NavigationGroup
